import config from "../config";
import { ListActionProvider } from "@beeldit/core/actions/list/ListActionContext";
import { RemoveActionProvider } from "@beeldit/core/actions/remove/RemoveActionContext";
import { CreateActionProvider } from "@beeldit/core/actions/create/CreateActionContext";
import { EditActionProvider } from "@beeldit/core/actions/edit/EditActionContext";
import { useParams } from "react-router-dom";
import { GenerateSessionsActionProvider } from "../actions/generate-sessions/GenerateSessionsActionContext";
import { CancelActionProvider } from "../actions/cancel/CancelActionContext";
import SchedulesTablePage from "../components/SchedulesTablePage";

function SchedulesPage() {
  let { customerTreatmentId } = useParams();

  if (!customerTreatmentId) {
    customerTreatmentId = "0";
  }

  const tablePageParams = {
    modelConfig: config, // Configuración del modelo
    formDefaultValues: { customer_treatment_id: parseInt(customerTreatmentId) }, // Valores por defecto del formulario
    filters: { customer_treatment_id: parseInt(customerTreatmentId) }, // Valores por defecto del formulario
  };

  return (
    <CancelActionProvider>
      <GenerateSessionsActionProvider>
        <ListActionProvider key={config.modelName}>
          <RemoveActionProvider>
            <CreateActionProvider>
              <EditActionProvider>
                <>
                  <SchedulesTablePage {...tablePageParams} />
                </>
              </EditActionProvider>
            </CreateActionProvider>
          </RemoveActionProvider>
        </ListActionProvider>
      </GenerateSessionsActionProvider>
    </CancelActionProvider>
  );
}

export default SchedulesPage;
